import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import type { IAllowForbidden } from '@app/dashboard/types/shared/allowForbidden';

export const getSubscriptionData = ({ isLive }: { isLive: boolean }) => {
  const params = { is_live: isLive };
  const config = { allow403: true } as IAllowForbidden;

  return axiosPrivate.get(`/dashboard/api/v1/risk-center/subscriptions`, {
    params,
    ...config,
  });
};

export const addSubscription = (data: { merchant: number; plan: number }) => {
  return axiosPrivate.post(
    `/dashboard/api/v1/risk-center/subscriptions/`,
    data
  );
};
